import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import axios from 'axios';

Vue.use(ElementUI);
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

// 根据环境设置baseURL
if (process.env.NODE_ENV === 'production') {
  // 生产环境使用实际API地址
  axios.defaults.baseURL = 'https://app.homeliftbuy.com';
} else {
  // 开发环境使用相对路径，请求会发送到本地开发服务器
  axios.defaults.baseURL = '';
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');